/**
 * @generated SignedSource<<f18d968c052da6351db2e092cb284062>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutineOverviewListItem_routineOccasion$data = {
  readonly id: string;
  readonly sequenceNumber: number;
  readonly status: RoutineOccasionStatus;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircle_RoutineOccasion" | "WidgetRoutineOverviewListItemExpireText_routineOccasion">;
  readonly " $fragmentType": "WidgetRoutineOverviewListItem_routineOccasion";
};
export type WidgetRoutineOverviewListItem_routineOccasion$key = {
  readonly " $data"?: WidgetRoutineOverviewListItem_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewListItem_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetRoutineOverviewListItem_routineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "calculateNoTasks",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "calculateNotCompletedStarted",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "status",
      "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sequenceNumber",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetRoutineOverviewListItemExpireText_routineOccasion"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionStatusCircle_RoutineOccasion"
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "47c4b66752ebb954dc49bd1a5a3d50b8";

export default node;
